module.exports = __webpack_public_path__ + "img/cr.cb7edc60.svg";